import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  allRoles: [],
};

const userRole = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.GET_ALL_MY_ROLES):
      return { ...state, loading: false };
    case successAction(types.GET_ALL_MY_ROLES):
      return { ...state, allRoles: action.payload.data, loading: false };
    case requestAction(types.GET_ALL_MY_ROLES):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default userRole;
